
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/rapporter",
      function () {
        return require("private-next-pages/dashboard/rapporter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/rapporter"])
      });
    }
  